export default __webpack_public_path__ + "static/media/token_configuration.f9fa2cf7.png";